import { Component } from 'react';
import PropTypes from 'prop-types';

export default class HomePage extends Component {
  render() {
    return (
      this.props.children
    )
  }
}

HomePage.propTypes = {
  children: PropTypes.element.isRequired
}
